// src/phone-input/utils.ts
var ISO_REGEX = /^[a-z]{2}$/i;
var OFFSET = 127397;
function iso2FlagEmoji(iso) {
  if (!iso || !ISO_REGEX.test(iso)) {
    return;
  }
  const chars = Array.from(iso.toUpperCase()).map(
    (char) => char.charCodeAt(0) + OFFSET
  );
  return String.fromCodePoint(...chars);
}

export {
  iso2FlagEmoji
};
